import { ref as dbRef, get, push, set, remove } from 'firebase/database';
import { ref as storageRef, uploadBytes, getDownloadURL, deleteObject } from 'firebase/storage';
import { database, storage } from '../firebaseConfig';

// Executed contract documents for a deal. Files live in Firebase Storage under the deal's owner.
// Each file's details are kept on the deal so the title email step can list them.
// Files are removed by hand after closing, since the documents are kept in Skyslope.

const safeName = (name) => (name || 'file').replace(/[^A-Za-z0-9._-]/g, '_');

export const listDealDocuments = async (ownerUid, txId) => {
  if (!ownerUid || !txId) return [];
  const snap = await get(dbRef(database, `users/${ownerUid}/transactions/${txId}/documents`));
  if (!snap.exists()) return [];
  return Object.entries(snap.val())
    .map(([id, d]) => ({ id, ...d }))
    .sort((a, b) => (a.uploadedAt || '').localeCompare(b.uploadedAt || ''));
};

export const uploadDealDocument = async (ownerUid, txId, file, uploadedBy, category = null) => {
  const path = `deals/${ownerUid}/${txId}/${Date.now()}-${safeName(file.name)}`;
  await uploadBytes(storageRef(storage, path), file, { contentType: file.type || undefined });
  const url = await getDownloadURL(storageRef(storage, path));
  const record = {
    name: file.name,
    path,
    url,
    size: file.size || 0,
    uploadedAt: new Date().toISOString(),
    uploadedBy: uploadedBy || null,
    ...(category ? { category } : {}),
  };
  const newRef = push(dbRef(database, `users/${ownerUid}/transactions/${txId}/documents`));
  await set(newRef, record);
  return { id: newRef.key, ...record };
};

export const deleteDealDocument = async (ownerUid, txId, doc) => {
  if (doc.path) await deleteObject(storageRef(storage, doc.path)).catch(() => {});
  await remove(dbRef(database, `users/${ownerUid}/transactions/${txId}/documents/${doc.id}`));
};
